const SITE_NAME = 'Hangar X Daily';
const TWITTER_MAX_TEXT = 240;

/**
 * Rich share copy for email, clipboard, and native share (article "widget").
 * @param {{ title?: string, takeaway?: string, category?: string, webUrl?: string }} article
 * @param {{ siteName?: string }} [opts]
 */
export function buildArticleSharePayload(article, opts = {}) {
  const siteName = opts.siteName || SITE_NAME;
  const url = String(article?.webUrl || '').trim();
  const title = String(article?.title || 'Brief article').trim();
  const takeaway = String(article?.takeaway || '').trim();
  const category = String(article?.category || '').trim();

  const blocks = [title];
  if (takeaway) blocks.push(`KEY TAKEAWAY: ${takeaway}`);
  if (category) blocks.push(category);
  blocks.push(`Read on ${siteName}`, url);
  const text = blocks.join('\n\n');

  const tweetLead = takeaway
    ? `${title} — ${takeaway}`
    : title;
  const tweetSuffix = url ? `\n\n${url}` : '';
  let tweetText = `${tweetLead}${tweetSuffix}`;
  if (tweetText.length > 280) {
    const budget = TWITTER_MAX_TEXT - tweetSuffix.length;
    tweetText = `${tweetLead.slice(0, Math.max(0, budget - 1)).trim()}…${tweetSuffix}`;
  }

  return {
    url,
    title,
    text,
    tweetText,
    emailSubject: `${siteName}: ${title}`,
    emailBody: text,
  };
}

/** @param {string} url */
export function linkedInShareUrl(url) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
}

/**
 * @param {string} url
 * @param {string} [text]
 */
export function twitterShareUrl(url, text) {
  const params = new URLSearchParams();
  if (text) params.set('text', text);
  else if (url) params.set('url', url);
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

/**
 * @param {string} subject
 * @param {string} body
 */
export function mailtoShareUrl(subject, body) {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  return `mailto:?${params.toString()}`;
}

/** @param {string} text */
export async function copyShareText(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  return false;
}

/** @param {{ title: string, text: string, url: string }} payload */
export async function nativeShareArticle(payload) {
  if (typeof navigator === 'undefined' || !navigator.share) return false;
  await navigator.share({
    title: payload.title,
    text: payload.text,
    url: payload.url,
  });
  return true;
}
